/*
 * @Descripttion: 
 * @version: 
 * @Author: TangXihao
 * @Date: 2020-12-10 14:31:32
 * @LastEditors: TangXihao
 * @LastEditTime: 2020-12-10 14:43:55
 */
import React, { Component } from 'react'
import './index.css'

import { Form, Input, Button } from 'antd';

class MyLoginLog extends Component {

    render() {
        return (
            <div>
              放置登录记录
            </div>
        )
    }
}

export default MyLoginLog